
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DesktopSidebar from '@/components/navigation/DesktopSidebar';
import MobileNavigation from '@/components/navigation/MobileNavigation';
import { MaintenanceGuard } from '@/components/guards/MaintenanceGuard';
import { useAuth } from '@/hooks/useAuth';
import { useRealtimeInit } from '@/hooks/useRealtimeInit';

const MainLayout = () => {
  const { user } = useAuth();
  const location = useLocation();
  
  // Initialize realtime only after user is authenticated
  useRealtimeInit();

  // Check if we're on a chat conversation page
  const isChatConversationPage = location.pathname.includes('/main/chat/') && 
                                location.pathname !== '/main/chats';

  if (!user) {
    return null;
  }

  return (
    <MaintenanceGuard>
      <div className="min-h-dvh bg-gradient-to-br from-black via-gray-900 to-black" style={{ touchAction: 'manipulation', overscrollBehavior: 'none' }}>
        {/* Desktop Sidebar - esconder em páginas de chat conversation */}
        {!isChatConversationPage && (
          <div className="hidden md:block">
            <DesktopSidebar />
          </div>
        )}
        
        {/* Main Content */}
        <div className={isChatConversationPage ? '' : 'md:ml-52 lg:ml-64'}>
          <main className="min-h-screen">
            <Outlet />
          </main>
        </div>
        
        {/* Mobile Navigation - esconder em páginas de chat conversation */}
        {!isChatConversationPage && (
          <div className="md:hidden">
            <MobileNavigation />
          </div>
        )}
      </div>
    </MaintenanceGuard>
  );
};

export default MainLayout;
